<div class="footer">
    <div class="content-container">
    <!-- <div class="borderhr"></div> -->
    <div class="mobilehidden">
        <div class="pure-u-md-5-24 pure-u-lg-5-24">
            <a href="https://www.csl.com/we-are-csl/our-businesses-and-products/csl-behring" target="_blank"><img src="/assets/img/CSLBehring-white.svg"></a>
        </div>
    
        <div class="pure-u-md-19-24 pure-u-lg-19-24 anchorlinks">
           <a href="https://privacy.csl.com" target="_blank">Privacy Notice</a>|       
           <a href="https://www.csl.com/terms-of-use" target="_blank">Terms of Use</a>|       
           <a href="https://www.csl.com/we-are-csl" target="_blank">About CSL Behring</a>|       
           <a href="/cookie-policy">Cookie Policy</a>
        </div>
        <div class="footerinfo">
            <div>
                <b>©2024 CSL Behring LLC.</b>
            </div>
            <div>1020 First Avenue, PO Box 61501, King of Prussia, PA 19406-0901 USA</div>
            <div class="pure-g">
                <div class="pure-u-12-24"><b>www.CSLBehring.com</b>     <b>&nbsp;USA-GDM-0079-APR24</b></div>
                <div class="pure-u-12-24 divinfo">This site is intended for US Healthcare Professionals only.</div>
            </div>
        </div>
    </div>
    <div class="desktophidden">
    
    
      
      <div class="pure-u-24-24">
        <a href="https://www.csl.com/we-are-csl/our-businesses-and-products/csl-behring" target="_blank"><img  src="/assets/img/CSLBehring-white.svg"></a>
      </div>
      <div class="footerinfo">
        <div>
          <b>©2024 CSL Behring LLC.</b>
        </div>
        <div>1020 First Avenue, PO Box 61501, King of Prussia, PA 19406-0901 USA</div>
        <div class="pure-g">
          <div class="pure-u-24-24"><b>www.CSLBehring.com</b>     <b>&nbsp;USA-GDM-0079-APR24</b></div>
        </div>
        <div class=" anchorlinks">
        <a href="https://privacy.csl.com" target="_blank">Privacy Notice</a>
        <a href="https://www.csl.com/terms-of-use" target="_blank">Terms of Use</a>
        <a href="https://www.csl.com/we-are-csl" target="_blank">About CSL Behring</a>
        <a href="/cookie-policy">Cookie Policy</a>
        </div>
        <div class="pure-g">
          <div class="pure-u-24-24 divinfo">This site is intended for US Healthcare Professionals only.</div>
        </div>
      </div>
    </div>
    </div>
    </div>
    